import { Action, combineSlices, configureStore, Reducer } from '@reduxjs/toolkit';

import uiSlice from './uiSlice';
import windowsSlice from './windowsSlice';
import { dbReducer } from '../db/dbReducer';
import { RootState } from './rootState';
import { registerCommandListeners } from '../chrome/chromeCommandListeners';

// Only import in dev; Vite replaces import.meta.env.DEV with `false` in production
// builds so tree-shaking eliminates the logger and its JSON serialization overhead.
import logger from 'redux-logger'

const sliceReducers = combineSlices(uiSlice, windowsSlice);

const reducers: Reducer<RootState, Action> = (
  state: RootState | undefined,
  action: Action<string>
) => {
  const slicesProcessedState: RootState = sliceReducers(state, action);
  // const autotaggedState: RootState = autotagReducer(slicesProcessedState, action);
  const globalProcessedState: RootState = dbReducer(slicesProcessedState, action);
  const result: RootState = globalProcessedState;
  return result;
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => {
    // serializableCheck recursively walks the entire state tree on every dispatch.
    // With thousands of tabs and URL maps it takes ~2s per dispatch — unusable in dev.
    // Non-serializable values don't exist in this state (no Dates, Functions, etc.),
    // so the check provides no safety benefit here.
    const base = getDefaultMiddleware({ serializableCheck: false });
    return import.meta.env.DEV ? base.concat(logger) : base;
  },
});

registerCommandListeners(store);

export type AppDispatch = typeof store.dispatch;

export default store;
